<script>
import ContributorPortrait from './ContributorPortrait'
import ContentEmergencyButtonBlock from './ContentEmergencyButtonBlock'

export default {
    name: 'QuestionStatement',
    components: {
        ContributorPortrait,
        ContentEmergencyButtonBlock,
    },
    methods: {
        getParsedQuote(quote) {
            return quote.replace(/"(.*?)"/g, "«$1»");
        }
    },
    props: {
        content: Array,
        contributor: Object,
    },
};
</script>

<template>
    <article v-bind:class="['question-statement', { 'question-statement--no-contributor': !contributor }]">
        <aside class="question-statement__contrubutor" v-if="contributor" >
            <contributor-portrait v-bind:portrait="contributor" v-bind:showRelatedAnswersLink="true" v-bind:prefix="$t('questionStatement.portraitPrefix')" />
        </aside>
        <div class="question-statement__text">
            <div class="question-statement__paragraph"
                v-for="(paragraph, i) in content"
                v-bind:key="i"
                v-bind:class="'question-statement__paragraph--' + paragraph.acf_fc_layout">
                    <div v-if="paragraph.acf_fc_layout === 'text_block'" v-html="paragraph.text"></div>
                    <p v-if="paragraph.acf_fc_layout === 'quote_block'">{{ getParsedQuote(paragraph.quote) }}</p>
                    <content-emergency-button-block class="question-statement__emergency-btn" v-if="paragraph.acf_fc_layout === 'emergency_button'" v-bind:data="paragraph" />
            </div>
        </div>
    </article>
</template>

<style lang="scss">
.question-statement {
    display: flex;

    @include breakpoint(sm-down) {
        display: block;
    }
}
.question-statement--no-contributor {
    margin-left: 11.52rem;

    @include breakpoint(sm-down) {
        margin-left: 0;
    }
}
.question-statement__contrubutor {
    min-width: 32.5rem;
    margin-bottom: 4.8rem;
}
.question-statement__text {
    margin-left: 3.2rem;

    @include breakpoint('xs-down') {
        margin-left: 2.08rem;
    }
}
.question-statement--no-contributor .question-statement__text {
    margin-left: 0;
}
.question-statement__paragraph {
    margin: -0.64rem 0 0;
    font-size: 1.8rem;
    letter-spacing: 0.033rem;
    line-height: 1.667;

    @include breakpoint('sm-down') {
        line-height: 1.5;
    }
}
.question-statement__paragraph--quote_block {
    margin: 6rem 4.4rem 7rem;
    font-size: 4rem;
    font-weight: 700;
    font-style: italic;
    letter-spacing: 0.027rem;
    line-height: 1.175;

    @include breakpoint(sm-down) {
        margin-right: 0;
        margin-left: 0;
        font-size: 3.52rem;
    }
}
.question-statement__paragraph--text_block p {
    margin: 0 0 2.4rem 0;
}
.question-statement__emergency-btn {
    margin-bottom: 0 !important;
}
</style>
